"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const DialogConstants = {
    ShowAlert: "@ReduxDialog/dialog/SHOW_ALERT",
    ShowInput: "@ReduxDialog/dialog/SHOW_INPUT",
    ShowSelect: "@ReduxDialog/dialog/SHOW_SELECT",
    ShowConfirm: "@ReduxDialog/dialog/SHOW_CONFIRM",
    ShowCustomDialog: "@ReduxDialog/dialog/SHOW_CUSTOM",
    ShowBlockedNumbersDialog: "@ReduxDialog/dialog/SHOW_BLOCKED_NUMBERS",
    ShowBlackWordDialog: "@ReduxDialog/dialog/SHOW_BLACK_WORD",
    Close: "@ReduxDialog/dialog/CLOSE"
};
exports.default = DialogConstants;


//////////////////
// WEBPACK FOOTER
// ./client/src/shared/Dialog/DialogConstants.ts
// module id = 476
// module chunks = 0 1 2